import React from 'react';
import { connect } from 'react-redux';

import FyorinLogo from './assets/fyorin-logo.svg'
import Tooltip from '@/tooltip';

const FyorinEmployeeStatus = ({
    payByCheque,
    isFyorin,
    fyorinPending,
    fyorinId
}) => {

    const payByBank = typeof (payByCheque) === 'string' ? ['yes', 'true'].includes(payByCheque) : payByCheque
    const synced = fyorinPending || (!fyorinId && payByBank) || !payByBank

    if (!isFyorin) return null

    return (
        <div style={{ marginLeft: 5, marginTop: 15, float: 'left' }}>
            <Tooltip content={`${!synced ? 'Employee is not synced with Fyorin' : 'Employee is Up To Date and synced'}`}>
                <img src={FyorinLogo} style={{ height: 30, filter: !synced ? 'grayscale(100%)' : undefined }} />
            </Tooltip>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const { bankDetails } = { ...state.employee };
    const { fyorinPending, fyorinId } = { ...state?.employee?.employeeDetails }
    const { fyorin } = { ...state?.integration?.payment }
    const { payByCheque } = { ...(bankDetails?.length > 0 && bankDetails[bankDetails.length - 1]) }

    return {
        fyorinPending,
        fyorinId,
        payByCheque,
        isFyorin: !!fyorin,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(FyorinEmployeeStatus);
